<template>
    <div></div>
</template>

<script>
    export default {
        name: "Javascript",
        props: ['field'],

        mounted() {
            this.renderJS()
        },
        methods: {
            renderJS(){
                eval(this.field.etiqueta)
            }
        }
    }
</script>

<style scoped>

</style>